import { type StateCreator } from 'zustand';

import { type AppState } from './store.js';

export interface DraftsSlice {
  readonly drafts: {
    /** In-memory only. Never persisted — see the whitelist in `store.ts`. */
    readonly byKey: Readonly<Record<string, unknown>>;
  };
  setDraft: (key: string, value: unknown) => void;
  clearDraft: (key: string) => void;
  /** Backs the navigate-away guard on multi-step forms. */
  hasUnsavedDrafts: () => boolean;
}

export const createDraftsSlice: StateCreator<AppState, [], [], DraftsSlice> = (set, get) => ({
  drafts: { byKey: {} },

  setDraft: (key, value) => {
    set((state) => ({ drafts: { byKey: { ...state.drafts.byKey, [key]: value } } }));
  },

  clearDraft: (key) => {
    set((state) => {
      const { [key]: _removed, ...rest } = state.drafts.byKey;
      return { drafts: { byKey: rest } };
    });
  },

  hasUnsavedDrafts: () => Object.keys(get().drafts.byKey).length > 0,
});
